import * as awilix from 'awilix';

import { AuthService } from './api/auth.service';
import { MunduClient } from './api/mundu.service';
import { HTTPService } from './api/http.service';
// import { ProxyService } from './api/proxy';
import { StorageService } from './api/storage.service';
import { ProxyService } from './api/proxy.service';

export interface Cradle {
    authService: AuthService;
    httpService: HTTPService;
    proxyService: ProxyService;
    munduClient: MunduClient;
    storageService: StorageService;
}

const container = awilix.createContainer<Cradle>();

container.register({
    authService: awilix.asClass(AuthService).singleton(),
    httpService: awilix.asClass(HTTPService).singleton(),
    proxyService: awilix.asClass(ProxyService).singleton(),
    munduClient: awilix.asClass(MunduClient).singleton(),
    storageService: awilix.asClass(StorageService).singleton(),
});

container.register({});

export default container;
